document.addEventListener('DOMContentLoaded', () => {
  var swiperFV = new Swiper('.secFV_swiper', {
  spaceBetween: 0,
  centeredSlides: true,
  slidesPerView: 1,
  loop: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.secFV_swiper .swiper-button-next',
    prevEl: '.secFV_swiper .swiper-button-prev',
  },
  autoplay: {
    delay: 3000, // 3秒ごとにスライド
    disableOnInteraction: false, // ユーザー操作後も自動再生を継続
  },
});

  const slides = document.getElementsByClassName('bl_fvCont_banner_item');
  const slideCount = slides.length;
  const paginationWidth = 26 * slideCount + 32;
  const style = document.createElement('style');
  style.innerHTML = `
      .bl_fvCont .swiper-pagination::after {
        width: ${paginationWidth}px;
      }
    `;
  document.head.appendChild(style);

  var swiperPick_up = new Swiper('.js_swiper-pick_up', {
    spaceBetween: 8,
    centeredSlides: false,
    slidesPerView: 1.46,
    breakpoints: {
      410: {
        slidesPerView: 2.3,
      },
      560: {
        slidesPerView: 2.45,
      },

      600: {
        slidesPerView: 2.8,
      },

      768: {
        spaceBetween: 40,
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: '.bl_pick_upSec .swiper-button-next',
      prevEl: '.bl_pick_upSec .swiper-button-prev',
    },
  });

  var swiperLineupThumbs = new Swiper('.js_lineup_thumbs', {
    slidesPerView: 1,
    slideToClickedSlide: true,
    spaceBetween: 8,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      350: {
        slidesPerView: 2,
      },
      548: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      800: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1120: {
        spaceBetween: 6,
        slidesPerView: 6,
      },
    },
  });

  var swiperLineupMain = new Swiper('.js_lineup_main', {
    autoHeight: true,
    speed: 500,
    spaceBetween: 40,
    thumbs: {
      swiper: swiperLineupThumbs,
    },
  });

  function diarySwiperInit() {
    var blockDiary_style = document.createElement('style');
    blockDiary_style.classList.add('blockDiary_style');
    blockDiary_style.innerHTML = `
      .bl_diaryPost_side .swiper-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr auto;
        column-gap: 20px;
        row-gap: 40px;
      }
  
      .bl_diaryCont_wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr) auto;
        column-gap: 60px;
        row-gap: 40px;
        padding-inline: 40px;
        justify-content: flex-start;
      }
  
      .bl_diaryCont .bl_diaryPost_main_wrapper {
        grid-area: 1 / 1 / 3 / 2; 
      }
  
      .bl_diaryCont .bl_diaryPost_side {
        grid-area: 1 / 2 / 4 / 3;
      }
  
      .bl_diaryCont .bl_btnCont {
        grid-area: 3 / 1 / 4 / 2;
        justify-content: center;
      }
    `;

    var swiperDiary;

    function initializeSwiper() {
      if (swiperDiary) {
        swiperDiary.destroy(true, true);
      }

      if (window.innerWidth < 768) {
        swiperDiary = new Swiper('.js_swiper-diary', {
          spaceBetween: 12,
          centeredSlides: false,
          slidesPerView: 1.5,
        });
        if (document.head.querySelector('.blockDiary_style')) {
          document.head.querySelector('.blockDiary_style').remove();
        }
      } else {
        if (!document.head.querySelector('.blockDiary_style')) {
          document.head.appendChild(blockDiary_style);
        }
      }
    }
    initializeSwiper();
    window.addEventListener('resize', initializeSwiper);
  }

  var swiperMovie = new Swiper('.js_swiper-movie', {
    spaceBetween: 40,
    centeredSlides: true,
    slidesPerView: 'auto',
    slidesPerView: 1,
    navigation: {
      nextEl: '.bl_movieCont .swiper-button-next',
      prevEl: '.bl_movieCont .swiper-button-prev',
    },

    breakpoints: {
      480: {
        spaceBetween: 40,
        slidesPerView: 1.5,
      },

      1120: {
        spaceBetween: 40,
        slidesPerView: 2,
        centeredSlides: false,
      },
    },
  });

  var accordions = document.querySelectorAll('.js_accordion');
  function slideToggle(element) {
    if (!element.classList.contains('isExpanded')) {
      element.style.height = element.scrollHeight + 'px';
      element.classList.add('isExpanded');
    } else {
      element.style.height = element.scrollHeight + 'px'; // required to start the transition
      element.classList.remove('isExpanded');
      setTimeout(() => {
        element.style.height = '0';
      }, 0);
    }
  }

  accordions.forEach(function (accordion) {
    accordion.addEventListener('click', function () {
      var toggle = this.querySelector('.js_toggle');
      var question = this.querySelector('.bl_qaCont_item_question');
      var answer = this.querySelector('.bl_qaCont_item_answer');

      if (toggle && question) {
        toggle.classList.toggle('isActive');
        question.classList.toggle('isActive');
      }

      if (answer) {
        slideToggle(answer);
      }
    });
  });

  diarySwiperInit();
});
